import T from "utils/T";

const ABNORMAL_GLOCOSE_COLORS = {
  H: '#FF995A',
  N: '#AAAAAA',
  L: '#5100FF',
  V: '#13C1C7',
};

export default ABNORMAL_GLOCOSE_COLORS;